/*
 * Copyright (c) 2017, Indigen Solutions. All rights reserved.
 *
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 *
 * This software is the confidential and proprietary information.
 *
 * You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement
 * you entered into.
 */

import { Model } from "../utils/json-api";

/**
 *
 */
export class Company implements Model {

    static get TYPE() {
        return "Company";
    }

    id: string;
    name: string;
    label: string;
    enabled?: boolean;
}


// WEBPACK FOOTER //
// ./src/models/Company.model.ts